import emailjs from '@emailjs/browser';

export const emailJsConfig = {
  publicKey: import.meta.env.VITE_EMAILJS_APY_KEY || 'demo-api-key',
  serviceId: import.meta.env.VITE_EMAILJS_SERVICE_ID || 'demo-service-id',
  templateId: import.meta.env.VITE_EMAILJS_TEMPLATE_CONTACTUS_ID || 'demo-template-id',
}

export const emailJs = emailjs.init(emailJsConfig.publicKey);